module.exports = __webpack_public_path__ + "static/img/skwhite_noslogan.5033894.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/skwhite_noslogan.png
// module id = 47
// module chunks = 2